import axios from 'axios'

import {
  DiscountData,
  ResponseDiscount,
  FetchDiscountRequest,
} from '~/discounts/model/discount.model'
import { getToken } from '~/net'

// eslint-disable-next-line import/prefer-default-export
export class DiscountService {
  constructor(private apiGateway: string) {}

  fetchDiscountService(
    fetchDiscountServiceRequest: FetchDiscountRequest,
  ): Promise<ResponseDiscount> {
    const {
      tariffId,
      subscriptionId,
      accountId,
      provinceId,
      brand,
      sub,
      bundleType,
    } = fetchDiscountServiceRequest

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }
        return axios.get<DiscountData>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/promotions`,
          {
            params: {
              ...{
                tariffId,
                provinceId,
                accountId,
              },
              ...(bundleType ? { bundleType } : {}),
            },
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => ({ subscriptionId, discount: resp.data }))
  }
}
